import {
  TagRequest,
  User,
  GraphicPublishingOptions,
  PublishingLocationExpandedDTO,
} from '@graphics/gfx-common/dist/types'
import {
  EditionStatus,
  EditionType,
  Language,
  EditionSubType,
} from '@graphics/gfx-common/dist/constants'

import { IInitAction } from './init'
import { IDataStreamData } from './datafile'
import { IPollingTaskData } from './polling'
import { UserDateType } from './date'
import { IOption } from './common'

// Action types
export enum types {
  CREATE_PACK__STARTED = 'CREATE_PACK__STARTED',
  CREATE_PACK__SUCCESS = 'CREATE_PACK__SUCCESS',
  CREATE_PACK__FAILURE = 'CREATE_PACK__FAILURE',
  CREATE_PACK_FROM_FILE__STARTED = 'CREATE_PACK_FROM_FILE__STARTED',
  CREATE_PACK_FROM_FILE__SUCCESS = 'CREATE_PACK_FROM_FILE__SUCCESS',
  CREATE_PACK_FROM_DATASTREAMURI__STARTED = 'CREATE_PACK_FROM_DATASTREAMURI__STARTED',
  GET_PACK_BY_ID__STARTED = 'GET_PACK_BY_ID__STARTED',
  GET_PACK_BY_ID__STARTED_SHADOW = 'GET_PACK_BY_ID__STARTED_SHADOW',
  GET_PACK_BY_ID__SUCCESS = 'GET_PACK_BY_ID__SUCCESS',
  GET_PACK_BY_ID__FAILURE = 'GET_PACK_BY_ID__FAILURE',
  GET_PACK_BY_ID__NO_UPDATES = 'GET_PACK_BY_ID__NO_UPDATES',
  UPDATE_PACK__STARTED = 'UPDATE_PACK__STARTED',
  UPDATE_PACK_POLLING__SUCCESS = 'UPDATE_PACK_POLLING__SUCCESS',
  UPDATE_PACK__SUCCESS = 'UPDATE_PACK__SUCCESS',
  UPDATE_PACK__FAILURE = 'UPDATE_PACK__FAILURE',
  DELETE_PACK__STARTED = 'DELETE_PACK__STARTED',
  DELETE_PACK__SUCCESS = 'DELETE_PACK__SUCCESS',
  DELETE_PACK_POLLING__SUCCESS = 'DELETE_PACK_POLLING__SUCCESS',
  DELETE_PACK__FAILURE = 'DELETE_PACK__FAILURE',
  VALIDATE_SLUG__STARTED = 'VALIDATE_SLUG__STARTED',
  VALIDATE_SLUG__SUCCESS = 'VALIDATE_SLUG__SUCCESS',
  DELETE_FILE__STARTED = 'DELETE_FILE__STARTED',
  DELETE_FILE__SUCCESS = 'DELETE_FILE__SUCCESS',
  DELETE_FILE__FAILURE = 'DELETE_FILE__FAILURE',
  DELETE_FILE_POLLING__SUCCESS = 'DELETE_FILE_POLLING__SUCCESS',
  PUBLISH_PACK__STARTED = 'PUBLISH_PACK__STARTED',
  PUBLISH_PACK_POLLING__SUCCESS = 'PUBLISH_PACK_POLLING__SUCCESS',
  PUBLISH_PACK__SUCCESS = 'PUBLISH_PACK__SUCCESS',
  PUBLISH_PACK__FAILURE = 'PUBLISH_PACK__FAILURE',
  CHECK_PACK_BEING_PUBLISHED = 'CHECK_PACK_BEING_PUBLISHED',
  CLEANUP_PACK = 'CLEANUP_PACK',
}

export enum PreviewOptions {
  useGraphicPreview = 'useGraphicPreview',
  useFilePreview = 'useFilePreview',
  useUploadedPreview = 'useUploadedPreview',
}

export interface ICreatePackAction {
  type: types.CREATE_PACK__STARTED
  packData: PackType
}

export interface ICreatePackFromFile {
  type: types.CREATE_PACK_FROM_FILE__STARTED
  groupId: string
  fileId: string
}

export interface ICreatePackFromDataStreamURI {
  type: types.CREATE_PACK_FROM_DATASTREAMURI__STARTED
  groupId: string
  title: string
  dataStreamURI: string
}

export interface ICreatePackFromFileSuccess {
  type: types.CREATE_PACK_FROM_FILE__SUCCESS
  groupId: string
  data: IPollingTaskData
}

export interface ICreatePackSuccessAction {
  type: types.CREATE_PACK__SUCCESS
  packData: PackType
  message: string
}

export interface IFailureAction {
  type:
    | types.CREATE_PACK__FAILURE
    | types.GET_PACK_BY_ID__FAILURE
    | types.UPDATE_PACK__FAILURE
    | types.DELETE_PACK__FAILURE
    | types.DELETE_FILE__FAILURE
    | types.PUBLISH_PACK__FAILURE
  message: string
  correlationId: string
}

export interface IGetPackByIdAction {
  type: types.GET_PACK_BY_ID__STARTED
  id: string
  group?: string
}

export interface IGetPackByIdShadowAction {
  type: types.GET_PACK_BY_ID__STARTED_SHADOW
  id: string
}

export interface IGetPackByIdSuccessAction {
  type: types.GET_PACK_BY_ID__SUCCESS
  packData: PackType
}

export interface IGetPackByIdNoUpdatesAction {
  type: types.GET_PACK_BY_ID__NO_UPDATES
}

export interface IUpdatePackAction {
  type: types.UPDATE_PACK__STARTED
  packData: PackType
}

export interface IUpdatePackPollingSuccessAction {
  type: types.UPDATE_PACK_POLLING__SUCCESS
  data: IPollingTaskData
}

export interface IUpdatePackSuccessAction {
  type: types.UPDATE_PACK__SUCCESS
  packData: PackType
  message: string
}

export interface IDeletePackAction {
  type: types.DELETE_PACK__STARTED
  id: string
}

export interface IDeletePackSuccessAction {
  type: types.DELETE_PACK__SUCCESS
  message: string
}
export interface IDeletePackPollingSuccessAction {
  type: types.DELETE_PACK_POLLING__SUCCESS
  data: IPollingTaskData
}

export interface IValidateSlugAction {
  type: types.VALIDATE_SLUG__STARTED
  slug: string
  language: EditionLanguage
  changeSlugCallback: (value: string) => void
  changeTopicsCodesCallback?: (value: FormObjectType[]) => void
  onValidate?: () => void
}

export interface IValidateSlugFinishedAction {
  type: types.VALIDATE_SLUG__SUCCESS
}

export interface IDeleteFileAction {
  type: types.DELETE_FILE__STARTED
  packId: string
  fileId: string
}
export interface IDeleteFileSuccessAction {
  type: types.DELETE_FILE__SUCCESS
  message: string
}

export interface IDeleteFilePollingSuccessAction {
  type: types.DELETE_FILE_POLLING__SUCCESS
  data: IPollingTaskData
  options?: any
}

export interface IPublishPackAction {
  type: types.PUBLISH_PACK__STARTED
  packData: PackType
}

export interface IPublishPackPollingSuccessAction {
  type: types.PUBLISH_PACK_POLLING__SUCCESS
  data: IPollingTaskData
}

export interface IPublishPackSuccessAction {
  type: types.PUBLISH_PACK__SUCCESS
  packData: PackType
}

export interface ICheckPackBeingPublishedAction {
  type: types.CHECK_PACK_BEING_PUBLISHED
}
export interface ICleanupPackAction {
  type: types.CLEANUP_PACK
}

export type PackActionsType =
  | ICreatePackAction
  | ICreatePackSuccessAction
  | ICreatePackFromDataStreamURI
  | IFailureAction
  | IGetPackByIdAction
  | IGetPackByIdShadowAction
  | IGetPackByIdSuccessAction
  | IGetPackByIdNoUpdatesAction
  | IUpdatePackAction
  | IUpdatePackSuccessAction
  | IDeletePackAction
  | IDeletePackSuccessAction
  | IValidateSlugAction
  | IValidateSlugFinishedAction
  | IDeleteFileAction
  | IDeleteFileSuccessAction
  | IDeleteFilePollingSuccessAction
  | IPublishPackAction
  | IPublishPackPollingSuccessAction
  | IPublishPackSuccessAction
  | ICheckPackBeingPublishedAction
  | ICleanupPackAction
  | IInitAction

// Reducer types
export interface IPreviewImages {
  previewURI?: string
  thumbnailURI?: string
  fileId: string | null
  newFileId?: string
  newTmpPreview?: string
}

export enum EditionLanguageInput {
  usePackValue = 'usePackValue',
}

export type PackLanguage = Language | '' | null
export type EditionLanguage = PackLanguage | EditionLanguageInput.usePackValue
export type Embed =
  | {
      declaration: string
      dependencies?: string
      secondary?: [
        {
          title: string
          declaration: string
          dependencies?: string
        }
      ]
    }
  | undefined

export interface IEditionMetadata extends UserDateType {
  id: string
  language: EditionLanguage
  metadataInherit?: string
  title: string | null
  slugline: string | null
  addToPackSlug: boolean
  description: string | null
  useGraphicPreview: boolean // on FE it's string, on BE - boolean
  editionName: string
  sourceFileURI?: string
  editionType: EditionType
  editionSubType: EditionSubType | null
  file: {
    deleted: boolean
    fileId: string
    fileName: string
    revisionGroupId: string
    revisionId?: string
    groupName?: string
    createdBy?: User
    created?: string
    filePath?: string
    version?: number
  }
  dataStreamData?: IDataStreamData
  dataStreamURI?: string
  dataStreamGraphic?: {
    dataStreamURI?: string
  }
  mediaType: string
  publishing: IEditionPublishing
  tags: string[]
  mimeType: string
  editStatus?: EditionStatus
  releaseNote?: string | null
  canDelete: boolean
  thumbnail?: any
  externalId?: any
  embargo?: any
  previewImages: IPreviewImages | null
  exact?: true
  deleting: boolean
  height?: number
  width?: number
  extensions?: string[]
  defaultFile?: string
  embed?: Embed
}

export interface IEditionPublishing {
  published: boolean
  publishing?: boolean
  publish?: boolean
  locations: PublishingLocationExpandedDTO[]
  promoDestinations: IPromoDestination[]
  promote: boolean
  changed: boolean
  publishedDataChanged: boolean
}

export interface IEditionMetadataInput
  extends Omit<IEditionMetadata, 'useGraphicPreview'> {
  isLynxSearchable: boolean
  publishingLocations: string[]
  title: string
  description: string
  slugline: string
  dataStreamURI: string
  useGraphicPreview: PreviewOptions // on FE it's string, on BE - boolean
}

export interface IPromoDestination {
  name: string
  promoted: boolean
  state: string
}

export interface IPackData {
  group: string
  title: string
  description: string
  byline: string
  language: Language | '' | null
  location?: ITypeaheadObject
  contacts: User[]
  slugline: string
  tags: TagRequest[]
  topicCodes: ITypeaheadObject[]
  previewImages: IPreviewImages | null
  canDelete?: boolean
}

export type PackType = IPackData &
  UserDateType & {
    isLoading?: boolean
    id: string
    editors?: User[]
    editions: IEditionMetadata[]
    editionTypes?: EditionType[]
    publishing: GraphicPublishingOptions
  }

export interface IPackInput extends UserDateType {
  group: string
  title: string
  description: string
  byline: string
  language: Language | ''
  location?: FormObjectType
  contacts: Array<IOption & { id?: string; name?: string }>
  slugline: string
  tags: ISelectInput[]
  topicCodes: FormObjectType[]
  editions: IEditionMetadataInput[]
  useGraphicPreview: PreviewOptions
  previewImages: IPreviewImages | null
  id: string
  publishing: GraphicPublishingOptions
}

export type PackSearchType = Omit<PackType, 'publishing'> & {
  publishing?: boolean
  expiryDate?: string
  nextScheduleDate?: string
  thumbnail: string | null
}

export interface ITypeaheadObject {
  rcsId: string
  n2000: string[] | null
  shortName: string
  additionalCodes?: string[] | null
  additionalCodesExpanded?: ITypeaheadObject[] | null
  parentRcsId?: string[]
  facetCode?: string[]
  conceptType?: number
  locationPath?: ITypeaheadObject[]
  slugline?: string
}

export type FormObjectType = ITypeaheadObject &
  IOption & {
    name?: string
  }

export interface ISelectInput extends IOption {
  id?: string
  name?: string
}

export type SingleEditionType = IEditionMetadata & {
  mediaType: string
  checked: boolean
  editionIndex: string
}

export interface IArchive extends UserDateType {
  archiveName: string
  archiveId: string
  editions: SingleEditionType[]
  editionIndex: string
}

export type GroupedEditionsType = Array<SingleEditionType | IArchive>

export interface IPromotedTo {
  LynxEvents: boolean
  Portal: boolean
}
